import React, {Fragment, useState} from 'react';
import {connect, useDispatch, useSelector} from 'react-redux'
import UIState from "../store/uiState";
import {RoundedModal} from "../components/Modal";
import {Button} from "../components/Button";
import Wallet from "../store/models/wallet";
import {formatBalance} from "../utils";
import {BigNumber, ethers} from "ethers";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import _ from "lodash";
import classNames from "classnames";
import walletThetaMobileLogo from "../assets/wallets/theta-mobile-wallet@2x.png";
import walletThetaWebLogo from "../assets/wallets/theta-web-wallet@2x.png";
import walletMetamaskLogo from "../assets/wallets/metamask@2x.png";
import {ModalTypes} from "../constants";


export class LoginModal extends React.Component {
    constructor(props) {
        super();
    }

    onClose = () => {
        this.props.dispatch(UIState.actions.hideModal());

        if(this.props.onClose){
            this.props.onClose();
        }
    }

    onThetaMobileWallet = () => {
        this.props.dispatch(Wallet.actions.loginWithWalletConnect());
    }

    onThetaWebWallet = () => {
        const confirmed = window.confirm('GroveWars via Web Wallet will require opening the wallet in your browser.\n\nWould you like to open the wallet now?')
        if(confirmed){
            this.props.dispatch(UIState.actions.hideModal(ModalTypes.Login));
            window.open('https://wallet.thetatoken.org?dapp-window-size=max&after-unlock=show-dapp-https://warrior.grovewars.com', '_blank');
        }
    }

    onMetamask = () => {
        this.props.dispatch(Wallet.actions.loginWithMetamask());
    }

    render() {
        const {t} = this.props;

        return (
            <RoundedModal title={'Connect your Wallet'}
                          className={'LoginModal'}
                          onClose={this.onClose}
            >
                <Fragment>
                    <div className={'ConnectYourWallet'}>
                        <div className={'ConnectYourWallet__options'}>
                            <Button size={'large'}
                                    className={'ConnectWalletButton'}
                                    onClick={this.onMetamask}
                            >
                                <img src={walletMetamaskLogo}/>
                            </Button>
                            <Button size={'large'}
                                    className={'ConnectWalletButton'}
                                    onClick={this.onThetaWebWallet}
                            >
                                <img src={walletThetaWebLogo}/>
                            </Button>
                            <Button size={'large'}
                                    className={'ConnectWalletButton'}
                                    onClick={this.onThetaMobileWallet}
                            >
                                <img src={walletThetaMobileLogo}/>
                            </Button>
                        </div>
                    </div>
                </Fragment>
            </RoundedModal>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {}
};

export default compose(
    withTranslation(),
    connect(mapStateToProps)
)(LoginModal);

